var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.shown ? 'thankyou-container pt-4 show' : 'thankyou-container pt-4'},[_c('div',[_c('h2',[_vm._v(_vm._s(_vm.$t('good_bye_title')))]),_c('h3',[_vm._v(_vm._s(_vm.$t('good_bye_message')))])])])}
var staticRenderFns = []

export { render, staticRenderFns }